export const LOGIN_USER_RETRAIT = "LOGIN_USER_RETRAIT"
export const LOGIN_SUCCESS_RETRAIT = "LOGIN_SUCCESS_RETRAIT"
export const LOGOUT_USER_RETRAIT = "LOGOUT_USER_RETRAIT"
export const LOGOUT_USER_SUCCESS_RETRAIT = "LOGOUT_USER_SUCCESS_RETRAIT"
export const API_ERROR_RETRAIT = "LOGIN_API_ERROR_RETRAIT"
export const SOCIAL_LOGIN_RETRAIT = "SOCIAL_LOGIN_RETRAIT"